<template>
  <div class="order-manage-goods-info">
     <!-- 仓库盘点货品类型选择 -->
    <div>
      <radio v-if="isInventory" v-model="form.countType" :options="inventoryType" class="radio_goods_content"  @change="handleChangeType"/>
    <div v-if="isSelectGoods">
      <p class="selectStyle" @click="showChooseGoods">
        <img class="goodsStyle" src="@/assets/img/goods.png" alt="">
        从货品库添加
      </p>
      <div
        :class="goodsActive ? 'goodsDetilsStyle' : 'goodsActive goodsDetilsStyle'"
      >
        <!-- <a-button class="goodsSelectStyle" type="primary" @click="showChooseGoods">从货品库选择</a-button> -->
        <a-table
          :columns="goodsColumns"
          :data-source="goods"
          :pagination="false"
          size="small"
          :row-key="(record, index) => index"
          :locale="{emptyText: '暂未选择货品'}"
          :scroll="{ x: 'calc(600px + 50%)'}"
          class="goods-table"
        >
          <span slot="numberTitle"><span class="titleStyle">*</span>数量</span>
          <span slot="weightTitle"><span class="titleStyle">*</span>总重量(kg)</span>
          <span slot="volumeTitle"><span class="titleStyle">*</span>总体积( M³)</span>
          <span slot="temperatureZoneTitle"><span class="titleStyle">*</span>温区</span>
          <span slot="companyTitle"><span class="titleStyle">*</span>{{scene === warehouseType.in ? '入库单位' : '出库单位'}}</span>
          <template slot="caozuo" slot-scope="text, rowData, index">
            <span class="deleteBtn deleteText" @click="onGoodsDelete(index)">删除</span>
            <template v-if="!isInventory">
               <template v-if="!isOrderDemoVersion">
              <span v-if="scene === warehouseType.in" class="deleteBtn" @click="batchProperties(index, rowData)">批属性</span>
              <!-- <a-dropdown v-if="scene === warehouseType.out">
                <a class="ant-dropdown-link">
                  指定条件<a-icon type="caret-down" />
                </a>
                <a-menu slot="overlay" @click="(e) => changeMenu(e, index, rowData)">
                  <a-menu-item v-for="item in DROPMENU" :key="item.value">
                    {{item.lable}}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <span v-if="scene === warehouseType.out" class="deleteBtn" @click="specifyBatch(index, rowData)">指定批次</span> -->
            </template>
            <span v-if="rowData.skuId"  class="deleteBtn" @click="copyGoods(rowData, index)">复制</span>
            </template>
          </template>
          <!-- 货品名称 -->
          <template slot="skuName" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                {{record.skuName}}
              </template>
              <div class="ellipsis">
                {{record.skuName}}
              </div>
            </a-tooltip>
          </template>
          <!-- 入库单位/出库单位 -->
          <template slot="skuUnit" slot-scope="text, record, index">
            <div>
              <a-form-model-item
                :rules="goodsPriceRules.skuUnit.RULES"
                :prop="`${propPrefix}.${index}.skuUnit`"
              >
                <a-select
                  v-model="goods[index]['skuUnit']"
                  :default-value="text"
                  style="width: 120px"
                  @change="changePrice(index)"
                >
                  <a-select-option
                    v-for="temp in record.unit"
                    :key="temp.value"
                    :value="temp.value"
                  >{{temp.value}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
          </template>
          <!-- 入库 预计存储时长 -->
          <template v-if="scene === warehouseType.in" slot="storageDuration" slot-scope="text, record, index">
            <div>
              <a-form-model-item
                  :rules="goodsPriceRules.storageDuration.RULES"
                  :prop="`${propPrefix}.${index}.storageDuration`"
              >
                <a-input v-model.number="goods[index]['storageDuration']" placeholder="请输入" :max-length="4" />
              </a-form-model-item>
            </div>
          </template>
          <!-- 入库 生产日期 -->
          <template v-if="scene === warehouseType.in" slot="productTime" slot-scope="text, record, index">
            <div>
              <a-form-model-item>
                <a-date-picker
                    v-model="goods[index]['productTime']"
                    format="YYYY-MM-DD"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择生产日期"
                />
              </a-form-model-item>
            </div>
          </template>
          <!-- 出库 指定批次 -->
          <template v-if="scene === warehouseType.out" slot="chooseBatch" slot-scope="text, record, index">
            <div>
             <outGoodsBatch :form-data="record" @change="onBatchChange($event, record, index)"></outGoodsBatch>
            </div>
          </template>
<!--          <template slot="designatedGoodsQuality" slot-scope="text, record, index">-->
<!--            <div>-->
<!--              <a-form-model-item-->
<!--                :prop="`${propPrefix}.${index}.designatedGoodsQuality`"-->
<!--              >-->
<!--                <a-select-->
<!--                  v-model="goods[index]['designatedGoodsQuality']"-->
<!--                  style="width: 120px"-->
<!--                >-->
<!--                  <a-select-option-->
<!--                    v-for="item in goodsQuality"-->
<!--                    :key="item.value"-->
<!--                    :value="item.value"-->
<!--                  >{{item.label}}</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-model-item>-->
<!--            </div>-->
<!--          </template>-->
          <!-- 数量 -->
          <template slot="number" slot-scope="text, record, index">
            <div>
              <a-form-model-item
                :rules="goodsPriceRules.number.RULES"
                :prop="`${propPrefix}.${index}.number`"
              >
                <InputNumber
                  v-model.trim="goods[index]['number']"
                  :class="getNumberClass(goods[index]['number'], record)"
                  @change="changePrice(index)"
                />
              </a-form-model-item>
            </div>
          </template>
          <!-- 重量 -->
          <template slot="weight" slot-scope="text, record, index">
            <div key="weight">
              <a-form-model-item
                :rules="goodsPriceRules.weight.RULES"
                :prop="`${propPrefix}.${index}.weight`"
              >
                <InputNumber v-model.trim="goods[index]['weight']" :precision="4" suffix="kg" @change="getSum(`${propPrefix}.${index}`,'weight')" />
              </a-form-model-item>
            </div>
          </template>
          <!-- 体积 -->
          <template slot="volume" slot-scope="text, record, index">
            <div key="volume">
              <a-form-model-item
                :rules="goodsPriceRules.volume.RULES"
                :prop="`${propPrefix}.${index}.volume`"
              >
                <InputNumber v-model.trim="goods[index]['volume']" :precision="4" suffix="M³" @change="getSum(`${propPrefix}.${index}`,'volume')" />
              </a-form-model-item>
            </div>
          </template>
          <!-- 指定批次 -->
          <template slot="stockBatch" slot-scope="text, record, index">
            <div key="stockBatch">
              <!-- <a-input v-if="scene === warehouseType.in"></a-input> -->
              <a-form-model-item
                v-if="scene === warehouseType.in"
                :prop="`${propPrefix}.${index}.stockBatch`"
              >
                <a-input v-model.trim="goods[index]['stockBatch']" :max-length="20" />
              </a-form-model-item>
              <span v-else>{{text}}</span>
            </div>
          </template>
          <template slot="storehouseId" slot-scope="text, record, index">
            <a-form-model-item  v-if="scene === warehouseType.out" :prop="`${propPrefix}.${index}.storehouseId`">
              <a-select
                v-model="goods[index]['storehouseId']"
                allow-clear
                show-search
                placeholder="请选择指定库位"
                @focus="handleFocus(record,index)"
                @change="(value)=>handleChangeStorehouseId(value,index, record)"
              >
                <a-select-option
                  v-for="item in loactionList"
                  :key="item.locationId"
                  :value="item.locationId"
                >{{item.locationCode}}</a-select-option>
              </a-select>
          </a-form-model-item>
          </template>
          <!-- 生产日期 -->
          <template slot="productTime" slot-scope="text, record, index">
            <a-form-model-item
              :prop="`${propPrefix}.${index}.productTime`"
            >
              <a-date-picker
                v-model="goods[index]['productTime']"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                placeholder="请选择生产日期"
              />
            </a-form-model-item>
          </template>
          <template slot="availableAmount" slot-scope="text, record">
            <span class="boldText">{{getNumberByBigOrDefault(record)}}{{record.skuUnit}}</span>
          </template>
          <template slot="availableStockStr" slot-scope="text, record">
            <span class="boldText">{{record.availableStockStr}}</span>
          </template>
          <!-- 温区 -->
          <template slot="temperatureZone" slot-scope="text, record, index">
            <el-row v-if="!isInventory">
              <el-col :span="goods[index]['temperatureZone'] === 'custom' ? 9 : 24">
                <a-form-model-item
                  :rules="goodsPriceRules.temperatureZone.RULES"
                  :prop="`${propPrefix}.${index}.temperatureZone`"
                >
                  <a-select
                    v-model="goods[index]['temperatureZone']"
                    :default-value="text"
                    style="width: 120px"
                  >
                    <a-select-option
                      v-for="(temp, i) in TEMPERATURES"
                      :key="i"
                      :value="temp.value"
                    >{{temp.label}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </el-col>
              <el-col v-if="filterTemper(index)" :span="1" style="min-height: 1px"></el-col>
                <el-col v-if="filterTemper(index)" :span="5">
                  <a-form-model-item
                    :rules="goodsPriceRules.lowtemp.RULES"
                    :prop="`${propPrefix}.${index}.lowtemp`"
                  >
                    <a-input v-model.number="goods[index]['lowtemp']" :max-length="3" type="age" />
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="2">
                  <p class="textIcon">—</p>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="5">
                  <a-form-model-item
                    :rules="goodsPriceRules.hightemp.RULES"
                    :prop="`${propPrefix}.${index}.hightemp`"
                  >
                    <a-input v-model.number="goods[index]['hightemp']" :max-length="3" type="age" />
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="2">
                  <p class="textIcon">℃</p>
                </el-col>
            </el-row>
            <span v-else>{{ text }}</span>
          </template>
        </a-table>
        <div v-if="scene === warehouseType.out && goods.length" class="goods-total">
          合计：{{`数量${totolSum.number}件/总重量${totolSum.weight}kg/总体积${totolSum.volume}M³`}}
        </div>
        <div v-if="goods && goods.length > SHOWLENGTH" class="moreData" @click="goodsActive = !goodsActive">
          <a-icon v-if="!goodsActive" type="down" />
          <a-icon v-else type="up" />
          {{ !goodsActive ? '展开更多货品' : '收起更多货品' }}
        </div>
      </div>
    </div>
    <div v-else>
       <el-row>
          <el-col :span="12">
            <a-form-model-item label="选择盘点库区" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" prop="warehouseAreas">
              <a-select
                v-model="form.warehouseAreas"
                mode="multiple"
                placeholder="请选择盘点库区"
                :options="warehouseArea"
                show-search
                allow-clear
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                @search="handleSearchArea"
                @change="handleAreaChange"
              ></a-select>
            </a-form-model-item>
          </el-col>
       </el-row>
    </div>
    </div>
    <SpecifyBatch ref="specifyBatch" @chooseBatch="chooseBatch" />
    <ChooseGoods ref="chooseGoods" @change="changeData"></ChooseGoods>
    <BatchProperties ref="batchProperties" @changeBatchProperty="changeBatchProperties" />
    <batch ref="batch" @changeBatch="changeBatch" />
    <location ref="location" @changeLocation="changeLocation" />
    <quality ref="quality" :goods-quality="goodsQuality" @changeQuality="changeQuality" />
  </div>
</template>

<script>
import InputNumber from "@/components/form/InputNumber.vue";
import {evil} from '@/utils/util'
import {getAvailableAmountByAttrs} from "@/api/warehouse";
import { mapGetters } from 'vuex'
import {warehouseZonePage} from '@/pages/data/InventoryManage/api'
import {
  goodsTableDetils,
  goodsTableType,
  goodsTypeRules,
  goodsRules,
  BATCHLIST,
  DROPMENU,
  goodsQuality,
  inventoryTableColumns,
} from "../goodsTable.js";
import ChooseGoods from "./ChooseGoods";
import { OVERWAREHOUSE,inventoryType } from '../constant';
import { warehouseGoods , getStorehousePage } from '../api'
import {getConfig} from '../../../orderManage/api'
import SpecifyBatch from './SpecifyBatch.vue'
import {goodsVerifyConfig} from '../../../orderManage/CreateOrder.vue'
import BatchProperties from './BatchProperties.vue';
import batch from './batch.vue';
import location from './location.vue';
import quality from './quality.vue';
import outGoodsBatch from "./outGoodsBatch.vue";
import radio from './warehouseInventory/radio.vue'

const warehouseType = {
    in: 'STORE',
    out: 'DELIVER'
}

const TEMPERATURES = [
  {
    value: "常温",
    label: "常温（环境温度）",
  },
  {
    value: "冷藏",
    label: "冷藏（0°C〜6°C）",
  },
  {
    value: "冷冻",
    label: "冷冻（-18°C以下）",
  },
  {
    value: "恒温",
    label: "恒温（15°C〜20°C）",
  },
  {
    value: "custom",
    label: "自定义温度",
  },
];
const goodsType = [
  {
    value: 0,
    label: "按货品明细",
  },
  {
    value: 1,
    label: "按货品品类",
  },
];
const SHOWLENGTH = 10;

// 需要重新验证表单值
const revalidate={
  weight:'volume',
  volume:'weight',
}
export default {
  components: {
    InputNumber,
    ChooseGoods,
    SpecifyBatch,
    BatchProperties,
    batch,
    location,
    quality,
    outGoodsBatch,
    radio
  },
  model: {
    prop: "goods",
    event: "change",
  },
  props: {
    propPrefix: {
      type: String,
      default: "",
    },
    goods: {
      type: Array,
      required: true,
      default: () => []
    },
    scene: {
      type: String,
      default: ''
    },
    deliverWarehouseCode: {
      type: String,
      default: ''
    },
    selectWarehouseid: {
      type: String,
      default: ''
    },
    shipperCode: {
      type: String,
      default: ''
    },
    isEditPage: {
      type: Boolean,
      default: false
    },
    oneMoreOrder: {
      type: Boolean,
      default: false
    },
    needTransport:{
      type:Number,
      default:1
    },
    temperatureLayer:{
      type:String,
      default: '全部'
    },
    form:{
      type:Object,
      default:()=>{}
    }
    // showAddButton: {
    //   default: false,
    //   type: Boolean,
    // },
    // showDeleteButton: {
    //   default: false,
    //   type: Boolean,
    // },
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      const path = rule?.field?.split('.')
      const index = path[path.length -2]
      const data = this.goods[index]
      const {skuUnit} = this.goods[index]
      if (value === '') {
        callback(new Error('请输入数量'));
      } else if (!this.isEditPage && !this.oneMoreOrder && skuUnit === data.bigUnit) {
        // 默认单位等于整单位时
        if(data.defaultUnit === data.bigUnit && value * 1 > data.stockNum){
          callback(new Error("库存不足"));
        } else if(data.defaultUnit === data.smallUnit && value * 1 > (data.stockNum / data.conversionRate)){
          callback(new Error("库存不足"));
        }
        callback();
      } else if (!this.isEditPage && !this.oneMoreOrder && skuUnit === data.smallUnit) {
        // 默认单位等于整单位时
        if(data.defaultUnit === data.bigUnit && value * 1 > data.stockNum * data.conversionRate){
          callback(new Error("库存不足"));
        } else if(data.defaultUnit === data.smallUnit && value * 1 > data.stockNum){
          callback(new Error("库存不足"));
        }
        callback();
      } else {
        callback();
      }
    };
    const numberValidator=(rules, value, callback) => {
        if(goodsVerifyConfig.value.amountConfig){
          const {lowerLimit,upperLimit}=goodsVerifyConfig.value.amountConfig
          if((lowerLimit&&value<=lowerLimit)||(upperLimit&&value>upperLimit)){
            callback(new Error('请输入正确的数量'));
          }
          callback()
        }
        callback()
      }
    const volumeValidator=(rules, value, callback) => {
        if(goodsVerifyConfig.value.volumeConfig){
          const {lowerLimit,rule,upperLimit}=goodsVerifyConfig.value.volumeConfig
          const path=rules.field.split('.')
          const {weight}=this.goods[path[path.length-2]]
          if(rule&&rule.length){
            rule[0]=weight||0
          }
          if((lowerLimit||upperLimit)&&(value<=lowerLimit||value>upperLimit)){
            callback(new Error('请输入合理的体积范围区间'));
          }else if(rule&&rule.length&&value>evil(rule.join(''))){
             callback(new Error('请输入合理的体积范围区间'));
          }
          callback()
        }
        callback()
      }
      const weightValidator=(rules, value, callback) => {
        if(goodsVerifyConfig.value.weightConfig){
          const {lowerLimit,rule,upperLimit}=goodsVerifyConfig.value.weightConfig
          const path=rules.field.split('.')
          const {volume}=this.goods[path[path.length-2]]
          if(rule&&rule.length){
            rule[0]=volume||0
          }
          if((lowerLimit||upperLimit)&&(value<=lowerLimit||value>upperLimit)){
            callback(new Error('请输入合理的重量范围区间'));
          }else if(rule&&rule.length&&value>evil(rule.join(''))){
             callback(new Error('请输入合理的重量范围区间'));
          }
          callback()
        }
        callback()
      }
    return {
      inventoryType,
      warehouseType,
      SHOWLENGTH,
      wrapperCol: 17,
      wrapperColmin: 15,
      goodsCategory: [],
      CustomerCodeAuth:[],
      TEMPERATURES,
      goodsType,
      goodsTableDetils,
      goodsPriceList: [],
      goodsActive: false,
      goodsTableType,
      goodsTypeRules,
      needTransportRules:{
        ...goodsRules,
        number:{
          ...goodsRules.number,
          RULES:[
            ...goodsRules.number.RULES,
             {validator:numberValidator,trigger: "change"},
            { validator: validatePass2, trigger: 'change' }
          ]
        },
        volume:{
          ...goodsRules.volume,
          RULES:[
            ...goodsRules.volume.RULES,
            {validator:volumeValidator,trigger: "change"}
          ]
        },
        weight:{
          ...goodsRules.weight,
          RULES:[
            ...goodsRules.weight.RULES,
            {validator:weightValidator,trigger: "change"}
          ]
        }
      },
      noTransportRules:{
        ...goodsRules,
        number:{
          ...goodsRules.number,
          RULES:[
            ...goodsRules.number.RULES,
            { validator: validatePass2, trigger: 'change' }
          ]
        },
      },
      goodsPriceRules:{
        ...goodsRules,
        number:{
          ...goodsRules.number,
          RULES:[
            ...goodsRules.number.RULES,
             {validator:numberValidator,trigger: "change"},
              { validator: validatePass2, trigger: 'change' }
          ]
        },
        volume:{
          ...goodsRules.volume,
          RULES:[
            ...goodsRules.volume.RULES,
            {validator:volumeValidator,trigger: "change"}
          ]
        },
        weight:{
          ...goodsRules.weight,
          RULES:[
            ...goodsRules.weight.RULES,
            {validator:weightValidator,trigger: "change"}
          ]
        }
      },
      tableInputList: ["number", "weight", "volume", "goodsValue"],
      OVERWAREHOUSE,
      goodsList: [],
      // NUMBERRULES: [{ validator: validatePass2, trigger: 'change' }],
      totolSum: {
        number: 0,
        weight: 0,
        volume: 0
      },
      BATCHLIST,
      DROPMENU,
      goodsQuality,
      isDone:false,
      loactionList:[],
      warehouseArea:[], // 盘点库区
    };
  },
  computed: {
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
    surplusOption() {
      return this.goodsCategory;
    },
    goodsColumns(){
      return !this.isInventory ? this.goodsTable : inventoryTableColumns;
    },
    goodsTable(){
        const list= goodsTableDetils
        return this.scene===warehouseType.out?list.filter(item=> item.key !=='skuNorms' && item.key !== 'storageDuration' && item.key !== 'productTime'&&!(item.key==='storehouseId'&&this.isOrderDemoVersion)): goodsTableDetils.filter(item=>item.key!=='availableAmount'&&item.key!=='chooseBatch'&&!(item.key==='productTime'&&!this.isOrderDemoVersion)&&item.key!=='storehouseId')
    },
    isInventory(){
      return this.scene === 'INVENTORY'
    },
    isSelectGoods(){
      // 订单类型不为盘点或者订单类型为盘点且选择类型为货品
      return this.scene !== 'INVENTORY' || (this.scene === 'INVENTORY' && this.form.countType===inventoryType[0].value)
    },
  },
  watch:{
     goods:{
      handler(goods){
        const list = JSON.parse(JSON.stringify(goods))
          if(!this.isDone&&list.length > 0 && (this.isEditPage || this.oneMoreOrder)){
            list.forEach(async (e, i)=>{
              await this.filterCompany(e).then((res)=>{
                list[i].unit = res
                  this.$set(this.goods, i, {...list[i]})
              })
            })
            this.isDone=true;
          } else {
            // this.$set(this,'goodsList', list)
          }
        this.$nextTick(() => {
          this.getSum()
        })
      },
      immediate: true
     },
    needTransport(value){
      this.goodsPriceRules=value?this.needTransportRules:this.noTransportRules
      this.$emit('refreshAll')
    },
    // deliverWarehouseCode: {
    //   handler(val) {
    //     if (this.scene===warehouseType.out) {
    //       this.getStorehousePage(val);
    //     }
    //   },
    //   immediate: true
    // }
  },
  async created() {
    this.goodsPriceRules=this.needTransport?this.needTransportRules:this.noTransportRules
    this.customerCode=this.$store.state.user.customerCode
    await this.init();
    setTimeout(()=>{
      this.goodsPriceList = JSON.parse(JSON.stringify(this.goods))
    }, 500)
  },
  mounted() {},
  methods: {
    getQuality(value) {
      const current = goodsQuality.find(item => item.value === value);
      return current.label
    },
    getSum(prop,col) {
      let number = 0;
      let weight = 0;
      let volume = 0
      this.goods.forEach(item => {
        number += parseFloat(item.number || 0)
        weight += parseFloat(item.weight || 0)
        volume += parseFloat(item.volume || 0)
      })
      this.totolSum = {
        number: number.toFixed(3),
        weight: weight.toFixed(4),
        volume: volume.toFixed(4),
      }
      if(prop){
        this.$emit('afreshVali',`${prop}.${revalidate[col]}`)
      }
    },
    changeBatchProperties(chooseIndex, row) {
      this.$set(this.goods, chooseIndex, {...row})
    },
    changeBatch(chooseIndex, row) {
      this.$set(this.goods, chooseIndex, {...row})
    },
    changeLocation(chooseIndex, row) {
      this.$set(this.goods, chooseIndex, {...row})
    },
    changeQuality(chooseIndex, row) {
      this.$set(this.goods, chooseIndex, {...row})
    },
    chooseBatch(list, skuCode, chooseIndex) {
      if (!list.length) {
        return
      }
      const current = this.goods[chooseIndex]
      this.goods.splice(chooseIndex, 1)
      list.forEach(item => {
        let i = -1;
        this.goods.filter((goodItem, index) => {
          if (goodItem.stockBatch === item.batchNo && goodItem.skuCode === skuCode) {
            i = index
          }
          return goodItem
        })
        if (i === -1) {
          this.goods.splice(chooseIndex, 0, {
            ...current,
            stockBatch: item.batchNo
          })
        }
      })
    },
    filterTemper(index){
      return this.goods[index].temperatureZone === 'custom'
    },
    async filterCompany(data){
      const res = await warehouseGoods({
        status: 'ENABLED',
        deleteStatus: 0,
        warehouseCode: this.deliverWarehouseCode, // 仓库id
        shipperCode: this.shipperCode, // 货主编号
        goodsCode: data.skuCode,
      })
      const list = []
      if(res && res.records && res.records.length > 0){
        const records = res.records[0]
        if(records.defaultUnit){
          list.push({
            value: records.defaultUnit,
          })
        }
        if(records.bigUnit && list.filter((e)=>e.value === records.bigUnit).length <= 0){
          list.push({
            value: records.bigUnit,
          })
        }
        if(records.smallUnit && list.filter((e)=>e.value === records.smallUnit).length <= 0){
          list.push({
            value: records.smallUnit,
          })
        }
      }
      return list
    },
    skuChange(value, index) {
      this.goodsCategory.forEach((e) => {
        if (value === e.dictionaryCode) {
          this.goods[index].skuName = e.dictionaryName;
        }
      })
    },
    changeData(data) {
      if (this.scene === warehouseType.out) {
        this.getOutData(data)
      } else if(this.scene === warehouseType.in) {
        this.getInData(data)
      }else{
        this.inventoryGoods(data)
      }
    },
    getOutData(data) {
      const arr = [];
      // const batchList = []
      // this.goods.forEach(item => {
      //   batchList.push(`${item.skuCode || ''}${item.stockBatch || ''}`)
      // })
      data.forEach(e => {
        const unit = []
        if(e.defaultUnit){
          unit.push({
            value: e.defaultUnit,
          })
        }
        if(e.bigUnit && unit.filter((n)=>n.value === e.bigUnit).length <= 0){
          unit.push({
            value: e.bigUnit,
          })
        }
        if(e.smallUnit && unit.filter((n)=>n.value === e.smallUnit).length <= 0){
          unit.push({
            value: e.smallUnit,
          })
        }
        // if (this.scene ===  warehouseType.out) {
        //   if (batchList.includes((e.shipperGoodsCode || '')+(e.stockBatch || ''))) {
        //     return
        //   }
        // }
        let conversionRate = 1
        const number = (e.number || 1) *1
        const batchVolume = (e.singleVolume || 0) * 1 * number
        const batchWeight = (e.singleWeight || 0) * 1 * number
        if ((e.skuUnit || e.defaultUnit) === e.smallUnit) {
          conversionRate = (e.conversionRate || 1)*1
        }
        const weight = (batchWeight / conversionRate).toFixed(4)
        const volume = (batchVolume / conversionRate).toFixed(4)
        arr.push({
          skuId: e.skuId || e.goodsId || e.id,
          skuCode: e.skuCode || e.shipperGoodsCode,
          skuName: e.skuName || e.goodsName,
          number: e.number ? e.number : undefined,
          weight: e.number ? weight : undefined,
          volume: e.number ? volume : undefined,
          skuNorms: e.norms,
          singleVolume: e.singleVolume || 0,
          singleWeight: e.singleWeight || 0,
          skuUnit: e.skuUnit ? e.skuUnit : e.defaultUnit,
          smallUnit: e.smallUnit,
          bigUnit: e.bigUnit,
          defaultUnit: e.defaultUnit,
          temperatureZone: e.temperatureZone || e.goodsTemperatureLayerName,
          // goodsValue: e.goodsPrice,
          stockBatch: e.batchNo || e.stockBatch,
          stockBatchType: '',
          id: e.id,
          unit,
          stockNum: e.stockNum,
          conversionRate: e.conversionRate,
          availableAmount: e.availableAmount,
          bigUnitAvailableNum: e.bigUnitAvailableNum,
          smallUnitAvailableNum: e.smallUnitAvailableNum,
        });
      })
      // const goodsLength = this.goods.length
      // this.goods.splice(0, goodsLength)
      // this.goods.push(...arr);
      arr.forEach((item)=>{
        // if(this.goods.some(goods=>goods.skuId===item.skuId)){
        //   const row= this.goods.find(goods=>goods.skuId===item.skuId);
        //   const newRow={
        //     ...row,
        //     weight:item.weight,
        //     number:item.number,
        //     volume:item.volume,
        //     unit:item.unit,
        //   }
        //   this.$set(this.goods,this.goods.findIndex(goods=>goods.skuId===item.skuId),newRow)
        // }else{
        //   this.goods.push(item);
        // }
        this.goods.push(item);
      })
      this.goodsPriceList = data.map((e) => {
        if (e.number > 1) {
          return {
            ...e,
            weight: e.weight / e.number,
            volume: e.volume / e.number,
            // goodsValue: e.goodsValue / e.number
          }
        }
        return {...e};
      })
    },
    getInData(data) {
      const arr = [];
      data.forEach((e) => {
        const unit = []
        if(e.defaultUnit){
          unit.push({
            value: e.defaultUnit,
          })
        }
        if(e.bigUnit && unit.filter((n)=>n.value === e.bigUnit).length <= 0){
          unit.push({
            value: e.bigUnit,
          })
        }
        if(e.smallUnit && unit.filter((n)=>n.value === e.smallUnit).length <= 0){
          unit.push({
            value: e.smallUnit,
          })
        }
        let conversionRate = 1
        const number = (e.number || 1) *1
        const batchVolume = (e.singleVolume || 0) * 1 * number
        const batchWeight = (e.singleWeight || 0) * 1 * number
        if ((e.skuUnit || e.defaultUnit) === e.smallUnit) {
          conversionRate = (e.conversionRate || 1)*1
        }
        const weight = (batchWeight / conversionRate).toFixed(4)
        const volume = (batchVolume / conversionRate).toFixed(4)
        arr.push({
          skuId: e.skuId || e.goodsId || e.id,
          skuCode: e.skuCode,
          skuName: e.skuName,
          number: e.number ? e.number : undefined,
          weight: e.number ? weight : undefined,
          volume: e.number ? volume : undefined,
          singleVolume: e.singleVolume || 0,
          singleWeight: e.singleWeight || 0,
          skuNorms: e.norms,
          skuUnit: e.skuUnit ? e.skuUnit : e.defaultUnit,
          smallUnit: e.smallUnit,
          bigUnit: e.bigUnit,
          defaultUnit: e.defaultUnit,
          temperatureZone: e.temperatureZone,
          goodsValue: e.goodsPrice,
          stockBatch: e.batchNo || e.stockBatch,
          stockBatchType: '',
          id: e.id,
          unit,
          stockNum: e.stockNum,
          conversionRate: e.conversionRate,
          designatedGoodsQuality: goodsQuality[0].value,
        });
      });
      // const goodsLength = this.goods.length
      // this.goods.splice(0, goodsLength)
      // this.goods.push(...arr);
      arr.forEach((item)=>{
        // if(this.goods.some(goods=>goods.skuId===item.skuId)){
        //   const row= this.goods.find(goods=>goods.skuId===item.skuId);
        //   const newRow={
        //     ...row,
        //     weight:item.weight,
        //     number:item.number,
        //     volume:item.volume,
        //     unit:item.unit,
        //   }
        //   this.$set(this.goods,this.goods.findIndex(goods=>goods.skuId===item.skuId),newRow)
        // }else{
        //   this.goods.push(item);
        // }
        this.goods.push(item);
      })
      this.goodsPriceList = arr.map((e) => {
        if (e.number > 1) {
          return {
            ...e,
            weight: e.weight / e.number,
            volume: e.volume / e.number,
            goodsValue: e.goodsValue / e.number
          }
        }
        return {...e};
      })
    },
    inventoryGoods(data){
      const list = [];
      data.forEach(e => {
         list.push({
          skuId: e.skuId || e.goodsId || e.id,
          skuCode: e.skuCode || e.goodsCode,
          shipperGoodsCode:e.shipperGoodsCode,
          skuName: e.skuName || e.goodsName,
          temperatureZone: e.temperatureZone || e.goodsTemperatureLayerName,
          availableAmount: e.availableAmount,
          conversionRate: e.conversionRate,
          bigUnitAvailableNum: e.bigUnitAvailableNum,
          smallUnitAvailableNum: e.smallUnitAvailableNum,
          skuUnit: e.skuUnit ? e.skuUnit : e.defaultUnit,
          smallUnit: e.smallUnit,
          availableNum:e.availableNum,
          availableStockStr:e.availableAmount
        });
      })
      this.$emit('changeGoods', list)
    },
    changeUnit(value, index) {
      console.log(value, index)
    },
    getInPrice(index) {
      let conversionRate = 1
      const current = this.goods[index]
      if (current.skuUnit === current.smallUnit) {
        conversionRate = (current.conversionRate || 1) * 1
      }
      const number = current.number * 1
      this.goods[index].weight = (number * (current.singleWeight || 0)/conversionRate).toFixed(3);
      this.goods[index].volume = (number * (current.singleVolume || 0)/conversionRate).toFixed(3);
    },
    getOutPrice(index) {
      let conversionRate = 1
      const current = this.goods[index]
      const number = current.number * 1
      if (current.skuUnit === current.smallUnit) {
        conversionRate = (current.conversionRate || 1)*1
      }
      this.goods[index].weight = ((current.singleWeight || 0) * number / conversionRate).toFixed(4);
      this.goods[index].volume = ((current.singleVolume || 0) * number / conversionRate).toFixed(4);
      // this.goods[index].goodsValue = (value * this.goodsPriceList[index].goodsValue).toFixed(2);
      this.$nextTick(() => {
        this.getSum()
      })
    },
    changePrice(index) {
      if (this.scene === warehouseType.out) {
        this.getOutPrice(index)
      } else {
        this.getInPrice(index)
      }
    },
    onGoodsDelete(index) {
      this.goods.splice(index, 1);
      // this.goodsList.splice(index, 1);
    },
    // 指定批次
    specifyBatch(index, row) {
      this.$refs.specifyBatch.show(index, row, this.deliverWarehouseCode)
    },
    batchProperties(index, row) {
      this.$refs.batchProperties.show(index, row);
    },
    changeMenu(e, index, row) {
      this.$refs[e.key].show(index, row)
    },
    isDisabled(code) {
      let res = false;
      this.goods.forEach((e) => {
        if (e.skuId === code) {
          res = true
        }
      })
      return res;
    },
    showChooseGoods() {
      if(!this.deliverWarehouseCode) {
        this.$message.warning('请先选择仓库')
        return
      }
      this.$refs.chooseGoods.show(this.isInventory?this.goods:[], this.scene,this.deliverWarehouseCode, this.shipperCode, this.selectWarehouseid, this.temperatureLayer);
    },
    init() {
      // this.setGoodsCategory();
      this.setCustomerCodeAuth()
    },
    // async setGoodsCategory() {
    //   const params = {
    //     status: 1,
    //     type: "publicGoods",
    //   };

    //   this.goodsCategory = await Base.getDictionary(params);
    // },
    async setCustomerCodeAuth() {
      const params = {
        keys: ['oms.order.check.stock.customer'],
      };
      const res = await getConfig(params);
      this.CustomerCodeAuth=res.configs[0]?.value?.split(',')
      this.isExistAuthList=this.CustomerCodeAuth.includes(this.customerCode)
      if(this.isExistAuthList){
        this.NUMBERRULES=[]
      }
    },
    handleGoodsCategoryChange() {
      const selectedGoods = this.goodsCategory.find(
        (goods) => goods.dictionaryCode === this.goods.skuId
      );
      this.$emit("change", {
        ...this.goods,
        skuName: selectedGoods.dictionaryName,
      });
    },
    onAdd() {
      this.$emit("add");
    },
    onDelete() {
      this.$emit("delete");
    },
    fillAvailableAmount(res, index){
      if(res.length) {
        let bigAmount = 0
        let smallAmount = 0
        const {bigUnit} = res[0]
        const {smallUnit} = res[0]
        const { conversionRate } = res[0]
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for(const i in res) {
          bigAmount+=res[i].bigAmount
          smallAmount+=res[i].smallAmount
        }
        this.$set(this.goods[index],'availableAmount', `${bigAmount}${bigUnit}${smallAmount}${smallUnit}`)
        this.$set(this.goods[index],'conversionRate', conversionRate)
        this.$set(this.goods[index],'smallUnit', smallUnit)
        this.$set(this.goods[index],'bigUnitAvailableNum', bigAmount)
        this.$set(this.goods[index],'smallUnitAvailableNum', smallAmount)
        // row.availableAmount =
      }
    },
    async onBatchChange(e, row, index) { // 出库选择了指定批次
      const attr = e
      // eslint-disable-next-line no-prototype-builtins
      if(attr.hasOwnProperty('attrValue')) {
        const res = await getAvailableAmountByAttrs({attributeName: attr?.attrCode,attributeValue: attr?.attrValue, goodsId: row.skuId, needAllStock: true, locationId: row.storehouseId})
        this.fillAvailableAmount(res, index)

      }
    },
    async handleFocus(row){
      this.loactionList = [];
      const res = await getStorehousePage({
        goodsId: row.skuId
      })
      this.loactionList = res||[];
    },
    async handleChangeStorehouseId(value,index, row){
      const current = this.loactionList.find(item => item.locationId === value)
      this.$set(this.goods[index], 'storehouseCode', current?.locationCode || '')
      this.$set(this.goods[index], 'storehouseId', current?.locationId || '')
      const attr = row?.batchAttrs[0]
      const res = await getAvailableAmountByAttrs({attributeName: attr?.attrCode,attributeValue: attr?.attrValue, goodsId: row.skuId, needAllStock: true, locationId: current?.locationId})
      this.fillAvailableAmount(res, index)
    },
    copyGoods(row, index) { // 复制商品
      const newGoods = JSON.parse(JSON.stringify(row));
      if(this.scene===warehouseType.in) {
        newGoods.productTime = undefined;
        newGoods.batchAttrs = []
        newGoods.number = 1
        this.goods.splice(index+1,0, newGoods)
      }else {
        newGoods.batchAttrs = [{
          attrCode: undefined,
          attrName: '',
          attrValue: undefined
        }]
        newGoods.storehouseId = undefined
        newGoods.storehouseCode = ''
        newGoods.number = 1
        this.goods.splice(index+1,0, newGoods)
        this.onBatchChange(newGoods.batchAttrs[0],newGoods, index+1)
      }
      // const goods = this.goods
    },
    // 根据当前单位转换可用库存至相应数量
    getNumberByBigOrDefault(row){
      const { skuUnit, smallUnit, conversionRate, bigUnitAvailableNum, smallUnitAvailableNum } = row
      if(skuUnit === smallUnit) { // 换算为小单位
        return bigUnitAvailableNum*conversionRate + smallUnitAvailableNum
      }
      const resultAvaiable = bigUnitAvailableNum + smallUnitAvailableNum/conversionRate
      // eslint-disable-next-line no-restricted-globals
      return  isNaN(resultAvaiable)?'--':resultAvaiable
    },
    getNumberClass(amount, row) {
      if(this.scene === warehouseType.in){
        return  ''
      }
      const num = this.getNumberByBigOrDefault(row)
      if(amount<=num) {
        return 'number-pass'
      }
        return 'number-reject'
    },
    handleChangeType(){
      if(this.form.countType === inventoryType[1].value){
        this.getWarehouseArea()
      }
      // this.$emit('change')
    },
    handleSearchArea(query){
      this.getWarehouseArea(query)
    },
    async getWarehouseArea(query){
      const res = await warehouseZonePage({size:30},{
        noTypeCodes:["VIRTUAL_GOODS_AREA"],
        warehouseCode: this.deliverWarehouseCode, // 仓库id
        zoneName:query||undefined,
      })
      this.warehouseArea = res.records.map(item=>{
        return {
          ...item,
          value:item.zoneCode,
          label:item.zoneName,
        }
      });
    },
    handleAreaChange(value,options){
      const arr = [];
      options.forEach(item=>{
        const data = item.data.props||{};
        arr.push({
          zoneId:data.id,
          zoneCode:data.zoneCode,
          zoneName:data.zoneName,
        })
      })
      this.form.zoneInfos = arr;
    },
  },
};
</script>

<style lang="less" scoped>
.order-manage-goods-info {
  display: flex;
  align-items: center;
  padding: 0px 32px;
  .goods-total {
    margin-top: 15px;
    color: #323232;
  }
  .textIcon {
    text-align: center;
    line-height: 40px;
  }
  /deep/ .ant-table-fixed-right {
    z-index: 2;
  }
  > div {
    width: 100%;
  }
  .goods-info-box {
    flex: 1;
    width: 100%;
  }
  .button-box {
    padding: 0 30px 0 80px;
  }
}
.form-item {
  display: flex;
  justify-content: space-between;
}
.itemWidth {
  width: 22%;
}
.tr {
  text-align: left;
  margin-top: 10px;
}
.goodsDetilsStyle {
  width: 100%;
  position: relative;
  padding-bottom: 30px;
  .goodsSelectStyle {
    margin: 15px 0;
  }
  .moreData {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: #fff;
    font-size: 12px;
    color: #06b880;
    position: absolute;
    bottom: 0;
    &:hover {
      cursor: pointer;
    }
  }
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
  }
  /deep/ .ant-form-explain {
    position: absolute;
  }
}
.goodsTypeStyle {
  width: 100%;
  margin-top: 15px;
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
  }
  /deep/ .ant-form-explain {
    position: absolute;
  }
}
.deleteBtn {
  color: #06b880;
  font-size: 14px;
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
}
.deleteText{
  color: #F56C6C;
}
.goodsActive {
  max-height: 690px;
  overflow: hidden;
}
.goods-table{
  .ant-input ,/deep/ .ant-select{
    width: 100% !important;
  }
  /deep/ .ant-col {
    width: 100% !important;
  }
  /deep/ .ant-table{
      font-size: 12px !important;
      .ant-table-thead{
          background-color: #f5f5f5;
          .ant-table-column-title{
            font-weight: bold;
          }
      }
  }
}
.titleStyle{
  color: red;
}
.number-pass {
  color: #06B880;
  font-weight: bold;
}
.number-reject {
  color: red;
  font-weight: bold;
}
.selectStyle{
  color: #06B880;
  margin-bottom: 20px;
  &:hover{
    cursor: pointer;
  }
}
.goodsStyle{
  width: 20px;
  height: 20px;
}
.boldText {
  font-weight: bold;
}
.radio_goods_content{
  margin-bottom: 16px;
}
</style>
